<template>
  <div>
    <div class="rr-builder-toolbar-sticky uk-visible@l" uk-sticky bottom=".rr-builder" offset="150">
      <div class="rr-builder-toolbar rr-builder-toolbar_vertical">
        <div class="rr-builder-toolbar__button-group" v-show="isContentEditable">
          <button @click="save" class="rr-builder-toolbar__button uk-button uk-button-primary"><i class="fal fa-save"></i></button>
          <button v-if="translatable" @click="cloneLanguage" class="rr-builder-toolbar__button uk-button uk-button-default"><i class="fal fa-clone"></i></button>
          <button @click="builderClose" class="rr-builder-toolbar__button uk-button uk-button-default"><i class="fal fa-times"></i></button>
        </div>
      </div>
    </div>

    <div :class="isContentEditable ? 'is-editable' : ''" v-if="isContentEditable">
      <div id="ck-top-bar" class="rr-builder-cke-top-bar"></div>
      <div>
        <div class="rr-builder-container">
          <builder-block v-for="(block, index) in blocks" :key="index" :block="block" :index="index" ref="blocks"> </builder-block>
        </div>
      </div>
      <!--<div id="ck-bottom-bar" class="rr-builder-cke-bottom-bar"></div>-->
    </div>
    <div v-else>
      <div class="rr-builder-container">
        <builder-runtime-template v-if="preview" :template="preparedPreview"></builder-runtime-template>
      </div>
    </div>
    <div class="rr-builder-toolbar">
      <button @click="edit" v-show="!isContentEditable"
              class="rr-builder-toolbar__button uk-button uk-button-primary"><i class="fal fa-pencil"></i></button>
      <div class="rr-builder-toolbar__button-group" v-show="isContentEditable">
        <div class="rr-builder-toolbar__add">
          <button @click="showAddBlockModal"
                  class="rr-builder-toolbar__button uk-button uk-button-primary"><i class="fal fa-plus"></i></button>
        </div>
        <button @click="builderClose" class="rr-builder-toolbar__button uk-button uk-button-default"><i class="fal fa-times"></i></button>
        <button v-if="translatable" @click="cloneLanguage" class="rr-builder-toolbar__button uk-button uk-button-default"><i class="fal fa-clone"></i></button>
        <button @click="save" class="rr-builder-toolbar__button uk-button uk-button-primary"><i class="fal fa-save"></i></button>
      </div>
    </div>

  </div>
</template>

<style lang="less">
  @import (reference) "~less/app";
  @import "~rubinred/content/less/rubinred-builder";

  /* toolbar */
  .rr-builder-toolbar {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: @builder-utility-margin 0;

    &__button.uk-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      font-size: 22px;
      line-height: 1;
      padding: 0;
      transition: background-color 0.3s ease;
    }

    &__button-group {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      width: 100%;

      .rr-builder-toolbar__button {
        margin: 0 10px;
      }
    }

    &__add {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: @builder-utility-margin*2;
      width: 100%;
      border: 2px dashed @global-border;
      margin-bottom: @builder-utility-margin*2;
    }


    &.rr-builder-toolbar_vertical  {
      display: inline-flex;

      .rr-builder-toolbar__button-group{
        display: flex;
        flex-direction: column;
        width: auto;
      }

      .rr-builder-toolbar__button {
        margin: 10px 0;
      }
    }
  }
  .rr-builder-toolbar-sticky {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    left: @grid-gutter-horizontal!important;
    width: auto!important;

    @media (min-width: @breakpoint-xlarge) {
      left: @grid-gutter-horizontal-l!important;
    }

    & + .uk-sticky-placeholder {
      height: 0!important;
    }

    &.uk-active {
      visibility: visible;
      opacity: 1;
    }
  }

  /* block container */
  .rr-builder {
    padding-top: ~'calc(@{section-padding-vertical-m} - @{builder-utility-margin})';
    padding-bottom: ~'calc(@{section-padding-vertical-m} - @{builder-utility-margin})';

    @media (min-width: @breakpoint-medium) {
      padding-top: ~'calc(@{section-padding-vertical-m} - @{builder-utility-margin}*2)';
      padding-bottom: ~'calc(@{section-padding-vertical-m} - @{builder-utility-margin}*2)';
    }
  }

  /* modals */
  .rr-builder-modal .uk-modal-dialog {
    /*background-color: #f9f9f9;*/
  }
  .rr-builder-modal__dialog,
  .rr-builder-dialog {
    .rr-builder-modal__footer.rr-builder-modal__footer_first-left,
    .rr-builder-dialog__footer.rr-builder-dialog__footer_first-left {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;

      .uk-button {
        margin: 3px;

        &:first-child {
          margin-left: 0;
          margin-right: auto;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      @media (max-width: @breakpoint-small-max) {
        flex-direction: column-reverse;

        .uk-button {
          display: block;
          width: 100%;
          margin: 3px 0;
        }
      }
    }
  }
  .rr-builder-modal {
    &__tab {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 0;
        border-bottom: 1px solid #e5e5e5;
      }

      > li > a {
        color: @builder-font-color;
        border-bottom: 1px solid transparent;
      }

      > .uk-active > a {
        border-color: @global-primary-background;
      }
    }

    &__switcher {
      border-top: none;
    }
  }

  /* ck editor */
  .rr-builder-cke-top-bar{
    position: fixed;
    bottom: 26px;
    left: @grid-gutter-horizontal;
    right: @grid-gutter-horizontal;
    z-index: 1001;

    @media (min-width: @breakpoint-xlarge) {
      left: @grid-gutter-horizontal-l;
      right: @grid-gutter-horizontal-l;
    }
  }
  .rr-builder-cke-bottom-bar{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1001;
  }

  .is-editable .rr-builder-widget{
    color: #ffffff;
  }
</style>

<script>
  import PrimaryLocaleAwareComponent from "rubinred/content/js/mixins/PrimaryLocaleAwareComponent";

  export default {
    mixins: [PrimaryLocaleAwareComponent],
    props: ['entityId', 'attributeId', 'translatable'],

    data() {
      return {
        blocks: [],
        dirty: false,
        preview: null,
        isContentEditable: false,
      }
    },

    created() {
      this.$root.$on('add-block', this.addBlock);
      this.$root.$on('remove-block', this.removeBlock);
      this.$root.$on('clone-block', this.cloneBlock);
      this.$root.$on('move-up-block', this.moveUpBlock);
      this.$root.$on('move-down-block', this.moveDownBlock);
      this.$root.$on('change-block-content', this.changeBlockContent);
      this.$root.$on('set-dirty', () => this.dirty = true);
      this.$root.$on('save-blocks-content', this.save);
      this.$root.$on('view-mode', this.view);
      this.$root.$on('do-clone-language', this.doCloneLanguage);
    },

    mounted() {
      this.fetch();
    },

    computed: {
      preparedPreview() {
        // Avoid Vue error due to multiple roots
        return '<div>'+this.preview+'</div>';
      },
      fetchUrl() {
        return window.App.get('builder.endpoints.fetch', '').replace('attribute-id', this.attributeId).replace('entity-id', this.entityId);
      },
      storeUrl() {
        return window.App.get('builder.endpoints.store', '').replace('attribute-id', this.attributeId).replace('entity-id', this.entityId);
      },
      cloneLanguageUrl() {
        return window.App.get('builder.endpoints.cloneLanguage', '').replace('attribute-id', this.attributeId).replace('entity-id', this.entityId);
      },
      html() {
        return this.blocks.map((block) => {
          let containerClass = [];
          if (block.blockWrap) {
            containerClass.push('uk-container');
          }
          let sectionClass = [`${block.blockPaddingTopClass}`, `${block.blockPaddingBottomClass}`];
          let blockClass = ['rr-builder-block-wrapper', `rr-builder-block-wrapper_flex-${block.blockValign}`];
          if (block.blockCollapse) {
            blockClass.push('rr-builder-block-wrapper_collapse');
          }
          if (block.blockReverse) {
            blockClass.push('rr-builder-block-wrapper_reverse');
          }
          if (block.blockHiddenSmall) {
            blockClass.push('rr-builder-block-wrapper_hidden-small');
          }
          if (block.blockCenterSmall) {
              containerClass.push('uk-text-center uk-text-left@s');
          }
          return `<div class="rr-builder-block-container ${sectionClass.join(' ')}" style="background-color: ${block.styleBackgroundRow.backgroundColor};">
                    <div class="${containerClass.join(' ')}"
                        style="background-color: ${block.styleBlockWrapper.backgroundColor}; background-image: ${block.styleBlockWrapper.backgroundImage}; background-position: ${block.styleBlockWrapper.backgroundPosition}; background-size: ${block.styleBlockWrapper.backgroundSize}; background-repeat: ${block.styleBlockWrapper.backgroundRepeat}; background-attachment: ${block.styleBlockWrapper.backgroundAttachment}; margin: ${block.styleBlockWrapper.marginTop} ${block.styleBlockWrapper.marginRight} ${block.styleBlockWrapper.marginBottom} ${block.styleBlockWrapper.marginLeft}; border-width: ${block.styleBlockWrapper.borderTop} ${block.styleBlockWrapper.borderRight} ${block.styleBlockWrapper.borderBottom} ${block.styleBlockWrapper.borderLeft}; border-style: ${block.styleBlockWrapper.borderStyle}; border-color: ${block.styleBlockWrapper.borderColor}; border-radius: ${block.styleBlockWrapper.borderRadius}">
                        <div class="${blockClass.join(' ')}" style="padding: ${block.styleBlock.paddingTop} ${block.styleBlock.paddingRight} ${block.styleBlock.paddingBottom} ${block.styleBlock.paddingLeft};">
                            ${block.content.replace(new RegExp('<p[^>]*>(\\s|&nbsp;|<\\/?\\s?br\\s?\\/?>)*<\\/?p>', 'g'), '')}
                        </div>
                    </div>
                </div>`;
        }).join('');
      }
    },

    methods: {
      edit() {
        this.isContentEditable = true;
        document.querySelector('body').classList.add('is-editable');
      },

      builderClose() {
        if (!this.dirty) {
          this.isContentEditable = false;
          document.querySelector('body').classList.remove('is-editable');
        } else {
          this.$root.$emit('open-builder-close-modal');
        }
      },

      view() {
        if (!this.dirty) {
          this.isContentEditable = false;
          document.querySelector('body').classList.remove('is-editable');
        } else {
          this.fetch();
          this.isContentEditable = false;
          document.querySelector('body').classList.remove('is-editable');
        }
      },

      showAddBlockModal() {
        this.$root.$emit('open-add-block-modal');
      },

      addBlock(block) {
        let computedBlock = Object.assign({}, {
          content: '',
          blockValign: 'top',
          blockWrap: true,
          blockReverse: false,
          blockCollapse: false,
          blockHiddenSmall: false,
          blockCenterSmall: false,
          blockBackgroundImage: 'none',
          blockPaddingTopClass: '',
          blockPaddingBottomClass: '',
          styleBackgroundRow: {
            backgroundColor: 'transparent',
          },
          styleBlockWrapper: {
            backgroundColor: 'transparent',
            backgroundImage: 'none',
            backgroundPosition: 'left top',
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'initial',
            borderTop: '0px',
            borderRight: '0px',
            borderBottom: '0px',
            borderLeft: '0px',
            borderColor: '#ffffff',
            borderStyle: 'none',
            borderRadius: '0px',
            marginTop: '0px',
            marginRight: 'auto',
            marginBottom: '0px',
            marginLeft: 'auto',
          },
          styleBlock: {
            paddingTop: '0px',
            paddingRight: '0px',
            paddingBottom: '0px',
            paddingLeft: '0px',
          }
        }, block);

        this.blocks.push(computedBlock);
        this.dirty = true;
        window.App.UIkit.update(document.querySelector('.rr-builder-toolbar-sticky'));
      },

      removeBlock(index) {
        this.blocks.splice(index, 1);
        this.dirty = true;
      },

      cloneBlock(index) {
        this.refreshBlocksContent();
        this.blocks.splice(index, 0, {...this.blocks[index]});
        this.dirty = true;

        setTimeout(() => {
          this.$refs.blocks[index + 1].$el.scrollIntoView({behavior: "smooth"});
        }, 0);
      },

      moveUpBlock(index) {
        if (index <= 0) {
          return
        }
        this.refreshBlocksContent();
        let currentBlock = this.blocks.splice(index, 1)[0];
        this.blocks.splice(index - 1, 0, currentBlock);
        this.dirty = true;

        setTimeout(() => {
          this.$refs.blocks[index - 1].$el.scrollIntoView({behavior: "smooth"});
        }, 0);
      },

      moveDownBlock(index) {
        if (index >= this.blocks.length) {
          return;
        }

        this.refreshBlocksContent();
        let currentBlock = this.blocks.splice(index, 1)[0];
        this.blocks.splice(index + 1, 0, currentBlock);
        this.dirty = true;

        setTimeout(() => {
          this.$refs.blocks[index + 1].$el.scrollIntoView({behavior: "smooth"});
        }, 0);
      },

      changeBlockContent(index, content) {
        if (index >= this.blocks.length) {
          return;
        }
        if (this.blocks[index].content === content) {
          return;
        }
        this.blocks[index].content = content;
        this.dirty = true;
      },

      refreshBlocksContent() {
        this.$refs.blocks.forEach((block, index) => {
          let content = block.$refs.editor.getData();
          if (this.blocks[index].content === content) {
            return;
          }
          this.blocks[index].content = content;
          this.dirty = true;
        });
      },

      fetch() {
        this.$root.$emit('loader-handler', true);
        window.App.Axios.get(this.fetchUrl)
          .then((response) => {
            if (typeof response.data === 'undefined') {
              this.notify(this.$t('rubinred.content.builder.errors.error_fetch', this.primaryLocale), {
                status: 'danger',
                pos: 'top-center'
              });
            } else if (response.data.success) {
              this.blocks = [];
              response.data.blocks.forEach(block => {
                this.addBlock(block);
              });
              this.preview = response.data.preview;
              this.dirty = false;
              this.isContentEditable = false;
              document.querySelector('body').classList.remove('is-editable');
            }
          })
          .catch((error) => {
            this.notify(error.response.data.message || this.$t('rubinred.content.builder.errors.error_catch', this.primaryLocale), {
              status: 'danger',
              pos: 'top-center'
            });
          })
          .then(() => {
            this.$root.$emit('loader-handler', false);
          });
      },

      cloneLanguage() {
        this.$root.$emit('open-clone-language-modal');
      },

      save() {
        this.refreshBlocksContent();
        if (!this.dirty) {
          this.isContentEditable = false;
          document.querySelector('body').classList.remove('is-editable');
          return;
        }

        this.$root.$emit('loader-handler', true);

        window.App.Axios.post(this.storeUrl, {
          html: this.html,
          blocks: this.blocks
        })
          .then((response) => {
            if (typeof response.data === 'undefined') {
              this.modalAlert(this.$t('rubinred.content.builder.errors.error_save', this.primaryLocale));
            } else if (response.data.success) {
              this.dirty = false;
              this.isContentEditable = false;
              document.querySelector('body').classList.remove('is-editable');
              this.preview = response.data.preview;
              this.modalAlert(response.data.message);
            }
          })
          .catch((error) => {
            this.modalAlert(error.response.data.message || this.$t('rubinred.content.builder.errors.error_save_catch', this.primaryLocale));
          })
          .then(() => {
            this.$root.$emit('loader-handler', false);
          });
      },

      doCloneLanguage(selected_language) {
        this.$root.$emit('loader-handler', true);

        window.App.Axios.post(this.cloneLanguageUrl, {
          selected_language: selected_language,
        })
          .then((response) => {
            if (typeof response.data === 'undefined') {
              this.modalAlert(this.$t('rubinred.content.builder.errors.error_save', this.primaryLocale));
            } else if (response.data.success) {
              this.dirty = false;
              this.isContentEditable = false;
              document.querySelector('body').classList.remove('is-editable');
              this.preview = response.data.preview;
              this.blocks = response.data.blocks;
              this.modalAlert(response.data.message);
            }
          })
          .catch((error) => {
            this.modalAlert(error.response.data.message || this.$t('rubinred.content.builder.errors.error_save_catch', this.primaryLocale));
          })
          .then(() => {
            this.$root.$emit('loader-handler', false);
          });
      },

      notify(message, options) {
        if (!window.App.UIkit.notification) {
          return;
        }
        window.App.UIkit.notification(message, options);
      },

      modalAlert(message, options = {labels: {ok: 'Ok'}}) {
        if (!window.App.UIkit.modal || !window.App.UIkit.modal.alert) {
          return;
        }
        window.App.UIkit.modal.alert(message, options);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/imbotex/extensions/rubinred/content/assets/js/components/BuilderApp.vue